import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import styled from "styled-components";
import {
    Button,
    ContentBlockLoader,
    SubmitButton,
    HelpText,
    FormLabel,
    FormikSelect,
    FormikInput,
    FormikCheckbox,
    FormikCheckboxTree,
    Panel,
    Loading,
    Tabordion,
    Row,
    Column,
    SimpleDropzone,
    FormRow,
    //@ts-ignore cortex
} from "@cortexglobal/rla-components";
///@ts-ignore cortex
import { parseValidationErrors } from "@cortexglobal/cortex-utilities";
///@ts-ignore cortex
import { trans } from "@cortexglobal/rla-intl";

import { TabordionGroup } from "../components/index";

const schema = Yup.object().shape({
    name: Yup.string().required("Required"),
    type: Yup.string().nullable(),
});

export type Group = ReturnType<typeof schema.validateSync> & {
    id?: number;
    uuid?: number;
    alias?: string;
};

export const GroupForm = ({ item, submitForm }) => {
    const [groupTypes, setGroupTypes] = useState([]);
    const [groupTypesLoaded, setGroupTypesLoaded] = useState(false);
    const [tab, setTab] = useState(0);

    useEffect(() => {
        axios.get(`/api/v1/admin/group/types`).then(({ data }) => {
            console.log(data);
            setGroupTypes(data);
            setGroupTypesLoaded(true);
        });
    }, []);
    const handleSubmit = (
        values: Group,
        { setErrors, setSubmitting, ...rest }
    ) => {
        submitForm(values, setSubmitting).catch((e) => {
            parseValidationErrors(e).then(({ errors }) => {
                console.log(setErrors, errors);
                setErrors(errors);
                setSubmitting(false);
            });
        });
    };
    return (
        <Formik
            initialValues={{
                name: item.name,
                type: item.type,
            }}
            onSubmit={handleSubmit}
            validationSchema={schema}
        >
            {({ isSubmitting, values, setFieldValue, errors }) => {
                // console.log(values);
                return (
                    <Form className="form-group">
                        <Tabordion current={tab} unmounts={false}>
                            <TabordionGroup
                                heading={<span>{trans("Details")}</span>}
                                onTabClick={() => setTab(0)}
                            >
                                {" "}
                                <FormRow
                                    name="name"
                                    label={trans("Name")}
                                    helpText={trans("Required")}
                                    error={errors.name}
                                >
                                    <FormikInput
                                        name="name"
                                        value={values.name}
                                        showError={false}
                                    />{" "}
                                </FormRow>
                                <FormRow
                                    name="type"
                                    label={trans("Type")}
                                    helpText={trans("Required")}
                                    error={errors.type}
                                >
                                    <ContentBlockLoader
                                        loaded={groupTypesLoaded}
                                    >
                                        <FormikSelect
                                            name="type"
                                            value={values.type}
                                            options={groupTypes}
                                            showError={false}
                                        />{" "}
                                    </ContentBlockLoader>
                                </FormRow>
                            </TabordionGroup>
                        </Tabordion>
                        <Row>
                            <Column medium={6} style={{ textAlign: "right" }}>
                                &nbsp;
                            </Column>
                            <Column
                                medium={3}
                                flex
                                style={{
                                    paddingBottom: "1rem",
                                    justifyContent: "flex-end",
                                }}
                            >
                                <SubmitButton
                                    label={trans("Save")}
                                    submitting={isSubmitting}
                                    type="primary"
                                />
                            </Column>
                        </Row>
                    </Form>
                );
            }}
        </Formik>
    );
};

export default GroupForm;
